---
title: "User Roles"
slug: user-roles
description: "hey circle has three user roles: Company Admin, Company Manager, and Scanner — each with clearly defined permissions."
keywords:
  - user roles
  - permissions
  - admin
  - manager
  - scanner
  - access
  - user management
---

## The three user roles

hey circle distinguishes three roles for users in your organization. The actions a user can perform depend entirely on their role.

### Company Admin

The Company Admin has full access to all platform features. This is typically the person who set up the company account or is responsible for settings and billing.

### Company Manager

The Company Manager can manage day-to-day operations: set up locations, create external recipients, and view analytics. However, they cannot manage users, configure integrations, or access billing.

### Scanner

The Scanner handles the day-to-day work: sending and receiving packages. They have no access to location management, analytics, or other administrative areas.

## Permissions overview

| Permission | Company Admin | Company Manager | Scanner |
|---|:---:|:---:|:---:|
| Manage users | ✅ | | |
| Manage integrations (Shopify) | ✅ | | |
| Billing | ✅ | | |
| Create / edit locations | ✅ | ✅ | |
| Create / edit external recipients | ✅ | ✅ | |
| View analytics | ✅ | ✅ | |
| Scan packages (send / receive) | ✅ | ✅ | ✅ |
| View inventory list | ✅ | ✅ | ✅ |
| View contracts | ✅ | ✅ | |

## Assigning roles

Roles are set when inviting a user. Only a **Company Admin** can invite users and change roles.

Role assignment takes place under **Settings → Users** in the top menu. There you can edit existing users and assign Scanners to one or more locations.

For step-by-step instructions, see the [Initial Setup](/app/help?article=initial-setup) article.

## Related Articles

- [Initial Setup](/app/help?article=initial-setup)
- [Internal vs. External Locations](/app/help?article=internal-vs-external-locations)
